/**
 * Null Print Provider - no-op implementation
 */
export class NullPrintProvider {
    printScreen() { }
    printFile(_fileName, _printerName, _printerPort, _errorMsgFlag) {
        return 0; // success
    }
}
//# sourceMappingURL=print.js.map